
import { 
    CHECK_PAYER_CONFIGURATION,
    CHECK_PAYER_CONFIGURATION_SUCCESS,
    CHECK_PAYER_CONFIGURATION_FAIL, 
    CHECK_PAYER_CONFIGURATION_RESET,
} from "../actions/checkPayerConfigurationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const checkPayerConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_PAYER_CONFIGURATION:
            return {
                ...state,
                apiState: "loading",
            };
        case CHECK_PAYER_CONFIGURATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case CHECK_PAYER_CONFIGURATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case CHECK_PAYER_CONFIGURATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default checkPayerConfigurationReducer;
